export default __webpack_public_path__ + "static/media/Baja de Prestación en convenio.602cc931.xlsx";